import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data,
            showPanel: false
        };
    }

    handleEdit = () => {
        this.props.context.componentParent.handleEditMedication(this.state.data);
    };

    handleDiscontinue = () => {
        this.props.context.componentParent.handleDiscontinueMedication(this.state.data);
    };

    handleArchive = () => {
        this.props.context.componentParent.handleArchiveMedication(this.state.data);
    };

    renderPanel() {
        const d = this.state.data;
        const ps = {
            overlay: { position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.3)',zIndex:1040 },
            panel: { position:'fixed',top:0,right:0,width:'420px',height:'100vh',background:'#fff',boxShadow:'-4px 0 20px rgba(0,0,0,0.15)',zIndex:1041,display:'flex',flexDirection:'column',overflowY:'auto' },
            header: { padding:'16px 20px',borderBottom:'1px solid #e0e0e0',display:'flex',alignItems:'center',justifyContent:'space-between',background:'#f8f9fa' },
            title: { margin:0,fontSize:'16px',fontWeight:600,color:'#333' },
            body: { padding:'20px',flex:1 },
            section: { marginBottom:'20px' },
            sectionTitle: { fontSize:'11px',fontWeight:700,color:'#888',letterSpacing:'0.08em',textTransform:'uppercase',marginBottom:'10px',paddingBottom:'6px',borderBottom:'1px solid #eee' },
            dl: { display:'grid',gridTemplateColumns:'140px 1fr',rowGap:'8px',margin:0 },
            dt: { fontSize:'13px',color:'#555',fontWeight:600,paddingRight:'8px' },
            dd: { fontSize:'13px',color:'#222',margin:0 },
            editBtn: { background:'#0066cc',color:'#fff',border:'none',borderRadius:'4px',padding:'6px 14px',fontSize:'13px',cursor:'pointer',marginRight:'8px' },
            closeBtn: { background:'transparent',border:'none',fontSize:'18px',cursor:'pointer',color:'#666' }
        };
        const isActive = d.status === 'active';
        const isDiscontinued = d.status === 'discontinued';
        const statusColor = isActive ? '#28a745' : isDiscontinued ? '#dc3545' : '#888';
        return ReactDOM.createPortal(
            <>
                <div style={ps.overlay} onClick={() => this.setState({ showPanel: false })} />
                <div style={ps.panel}>
                    <div style={ps.header}>
                        <h5 style={ps.title}>Medication Details</h5>
                        <div>
                            <button style={ps.editBtn} onClick={() => { this.setState({ showPanel: false }); this.handleEdit(); }}><i className="fas fa-pen" style={{ marginRight:5 }}></i>Edit</button>
                            <button style={ps.closeBtn} onClick={() => this.setState({ showPanel: false })}><i className="fas fa-times"></i></button>
                        </div>
                    </div>
                    <div style={ps.body}>
                        <div style={ps.section}>
                            <div style={ps.sectionTitle}>Medication Information</div>
                            <dl style={ps.dl}>
                                <dt style={ps.dt}>Name</dt><dd style={ps.dd}>{d.medication_name || d.name || '—'}</dd>
                                <dt style={ps.dt}>Generic</dt><dd style={ps.dd}>{d.generic_name || '—'}</dd>
                                <dt style={ps.dt}>Drug Class</dt><dd style={ps.dd}>{d.drug_class || '—'}</dd>
                                <dt style={ps.dt}>NDC</dt><dd style={ps.dd}>{d.ndc || '—'}</dd>
                                <dt style={ps.dt}>Status</dt>
                                <dd style={ps.dd}><span style={{ color: statusColor, fontWeight:600, textTransform:'capitalize' }}>{d.status || '—'}</span></dd>
                            </dl>
                        </div>
                        <div style={ps.section}>
                            <div style={ps.sectionTitle}>Prescription Details</div>
                            <dl style={ps.dl}>
                                <dt style={ps.dt}>Dose</dt><dd style={ps.dd}>{d.dose ? `${d.dose}${d.dose_unit ? ' ' + d.dose_unit : ''}` : '—'}</dd>
                                <dt style={ps.dt}>Frequency</dt><dd style={ps.dd}>{d.frequency || '—'}</dd>
                                <dt style={ps.dt}>Route</dt><dd style={ps.dd}>{d.route || '—'}</dd>
                                <dt style={ps.dt}>Prescriber</dt><dd style={ps.dd}>{d.prescriber || d.prescribing_physician || '—'}</dd>
                                <dt style={ps.dt}>Start Date</dt><dd style={ps.dd}>{d.start_date || '—'}</dd>
                                <dt style={ps.dt}>End Date</dt><dd style={ps.dd}>{d.end_date || '—'}</dd>
                            </dl>
                        </div>
                        {d.notes && (
                            <div style={ps.section}>
                                <div style={ps.sectionTitle}>Notes</div>
                                <div style={{ fontSize:'13px',color:'#333' }}>{d.notes}</div>
                            </div>
                        )}
                        <div style={ps.section}>
                            <div style={ps.sectionTitle}>Actions</div>
                            <div style={{ display:'flex', gap:'8px', flexWrap:'wrap' }}>
                                {isActive && (
                                    <button
                                        style={{ background:'#dc3545',color:'#fff',border:'none',borderRadius:'4px',padding:'6px 14px',fontSize:'13px',cursor:'pointer' }}
                                        onClick={() => { this.setState({ showPanel: false }); this.handleDiscontinue(); }}
                                    >
                                        <i className="fas fa-stop-circle" style={{ marginRight:5 }}></i>Discontinue
                                    </button>
                                )}
                                <button
                                    style={{ background:'#856404',color:'#fff',border:'none',borderRadius:'4px',padding:'6px 14px',fontSize:'13px',cursor:'pointer' }}
                                    onClick={() => { this.setState({ showPanel: false }); this.handleArchive(); }}
                                >
                                    <i className="fas fa-archive" style={{ marginRight:5 }}></i>Archive
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>,
            document.body
        );
    }

    render() {
        const isActive = this.state.data.status === 'active';
        const isDiscontinued = this.state.data.status === 'discontinued';

        return (
            <div className="action-buttons">
                <OverlayTrigger placement="top" overlay={<Tooltip>View Medication</Tooltip>}>
                    <button className="edit-order-btn" onClick={() => this.setState({ showPanel: true })}>
                        <i className="fas fa-eye"></i>
                    </button>
                </OverlayTrigger>
                {this.state.showPanel && this.renderPanel()}

                <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                    <button className="edit-order-btn" onClick={this.handleEdit}>
                        <i className="fas fa-pen"></i>
                    </button>
                </OverlayTrigger>

                {isActive && (
                    <OverlayTrigger placement="top" overlay={<Tooltip>Discontinue</Tooltip>}>
                        <button className="edit-order-btn" onClick={this.handleDiscontinue}>
                            <i className="fas fa-stop-circle text-danger"></i>
                        </button>
                    </OverlayTrigger>
                )}

                {isDiscontinued && (
                    <OverlayTrigger placement="top" overlay={<Tooltip>Discontinued</Tooltip>}>
                        <span className="text-muted" style={{ padding:'0 4px' }}>
                            <i className="fas fa-ban"></i>
                        </span>
                    </OverlayTrigger>
                )}

                <OverlayTrigger placement="top" overlay={<Tooltip>Archive</Tooltip>}>
                    <button className="edit-order-btn" onClick={this.handleArchive}>
                        <i className="fas fa-archive"></i>
                    </button>
                </OverlayTrigger>
            </div>
        );
    }
}
